import { useRoutes } from "react-router-dom";
import MainLayout from "../../MainLayout";
import { publicRoutes } from "./public.routes";
import { adminRoutes } from "./admin.routes";
import { studentRoutes } from "./student.routes";
//
import CompleteSignUp from "../../modules/authenticate/pages/CompleteSignUp";
//
import PersistLogin from "../../app/providers/context-provider/PersistLogin";
import RequireAuth from "../../app/providers/context-provider/RequireAuth";
import AdmissionTest from "../../modules/admin/layouts/admission-test/AdmissionTest";
import ChallengeCreation from "../../modules/challenge/layouts/ChallengeCreation";
import ChallengeHosting from "../../modules/challenge/layouts/ChallengeHosting";
import JoiningMainFrame from "../../modules/challenge/components/challenge-joining/joining-main-frame/JoiningMainFrame";
import JoiningNickNameFrame from "../../modules/challenge/components/challenge-joining/joining-nickname-frame/JoiningNickNameFrame";
import JoiningTeamComposeFrame from "../../modules/challenge/components/challenge-joining/joining-team-compose-frame/JoiningTeamComposeFrame";
import JoiningTeamChoiceFrame from "../../modules/challenge/components/challenge-joining/joining-team-choice-frame/JoiningTeamChoiceFrame";
import JoiningWaitingRoomFrame from "../../modules/challenge/components/challenge-joining/joining-waiting-room-frame/JoiningWaitingRoomFrame";
import ChallengePlay from "../../modules/challenge/page/ChallengePlay";
import LessonAssessmentPlay from "../../modules/student/pages/LessonAssessmentPlay";

const ROLES = { admin: "admin", student: "student" };

const Router = () => {
  const routes = [
    {
      path: "/",
      element: <MainLayout />,
      children: [
        ...publicRoutes,
        {
          element: <PersistLogin />,
          children: [
            {
              element: <RequireAuth allowedRoles={[ROLES.admin]} />,
              children: adminRoutes,
            },
            {
              element: <RequireAuth allowedRoles={[ROLES.student]} />,
              children: studentRoutes,
            },
            {
              path: ":sys_role/:stream/admission/test/questions",
              element: <AdmissionTest />,
            },
            {
              path: ":sys_role/challenges/create",
              element: <ChallengeCreation />,
            },
            {
              path: ":sys_role/challenge/hosting/:challenge_id",
              element: <ChallengeHosting />,
            },
            {
              path: ":sys_role/challenge/joining",
              element: <JoiningMainFrame />,
            },
            {
              path: ":sys_role/challenge/joining/setup/nickname",
              element: <JoiningNickNameFrame />,
            },
            {
              path: ":sys_role/challenge/joining/team/compose",
              element: <JoiningTeamComposeFrame />,
            },
            {
              path: ":sys_role/challenge/joining/team/choice",
              element: <JoiningTeamChoiceFrame />,
            },
            {
              path: ":sys_role/challenge/joining/waiting/room",
              element: <JoiningWaitingRoomFrame />,
            },
            {
              path: ":sys_role/challenge/play",
              element: <ChallengePlay />,
            },
            {
              path: ":sys_role/admission/test",
              element: <ChallengePlay />,
            },
            {
              path: ":sys_role/lessons/assessment",
              element: <LessonAssessmentPlay />,
            },
            {
              path: "signup/complete",
              element: <CompleteSignUp />,
            },
          ],
        },
      ],
    },
  ];

  return useRoutes(routes);
};

export default Router;
